import { type ReactNode } from "react";
import { PostHogProvider } from "./posthog-provider";
import { ClerkProvider } from "./clerk-provider";
import { QueryProvider } from "./query-provider";
import { AuthSyncProvider } from "./auth-sync-provider";
import { ModerationProvider } from "@/lib/moderation";

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <PostHogProvider>
      <ClerkProvider>
        <QueryProvider>
          <AuthSyncProvider>
            <ModerationProvider>
              {children}
            </ModerationProvider>
          </AuthSyncProvider>
        </QueryProvider>
      </ClerkProvider>
    </PostHogProvider>
  );
}
